<span class="glyphicon" :class="getIconClass"></span>